import { Button, Grid, TextField, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import theme from "../../theme";
import useButtonStyles from "../../styles/useButtonStyles";
import { useNavigate } from "react-router";
import Loader from "../ui/Loader";
import QRCode from "qrcode.react";
import axios from "axios";
import { APIConstants } from "../../constants/ApiConstants";
import { useAppSelector } from "../../redux/hooks";
import { stopSession } from "../../services/interceptors/ApiInterceptor";

const MerchantProfile = () => {
  const buttonStyles = useButtonStyles();
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(false);
  const [qrCode, setQrCode] = useState<string>("");
  const { selectedMerchatDetails } = useAppSelector(
    (state: any) => state.persistReducers.getMerchantList
  );
  const { merchantName, external_id, merchantId, companyName, storeCode } =
    selectedMerchatDetails;
  const handleLogout = async () => {
    setLoading(true);
    setTimeout(() => {
      stopSession();
      localStorage.clear();
      navigate("/login");
    }, 1000);
  };

  const handlePrint = () => {
    const qrImage: any = document.getElementById("qrCodeDiv");
    // debugger
    if (qrImage) {
      const canvas = qrImage.toDataURL();
      const printContent = `
      <!DOCTYPE html>
      <html lang="en">
      <head>
          <meta charset="UTF-8">
          <meta name="viewport" content="width=device-width, initial-scale=1.0">
          <title>Document</title>
          <style>
        body {
            margin: 0; /* Remove default margin */
            padding: 0; /* Remove default padding */
            overflow: hidden; /* Prevent horizontal scrollbars */
            display: flex;
            // height : 100%;
            // align-items : center;
            // justify-content : center;
        }
        
        img {
            padding-top:5rem;
            margin:auto;
            width: 50%;
            height: 50%;
            //object-fit: cover; /* Ensure the image covers the entire container */
        }
    </style>
      </head>
      <body>
          <img alt="canvas" src="${canvas}">
      </body>
      </html>
      `;
      const printWindow = window.open("", "", "");
      printWindow?.document.open();
      printWindow?.document.write(printContent);
      // printWindow?.document.close();
      printWindow?.focus();
      setTimeout(() => {
        printWindow?.print();
        printWindow?.close();
      }, 100);
    }
  };

  useEffect(() => {
    const generateQR = async () => {
      try {
        const qrCode = await axios.get(
          `${
            process.env.REACT_APP_API_URL +
            APIConstants.qrGenerate +
            "?id=" +
            merchantId
          }`
        );
        const qrText = qrCode?.data?.text;
        setQrCode(qrText);
      } catch (error) {
        console.error(error);
      } finally {
      }
    };
    generateQR();
  }, []);

  return (
    <>
      <Grid
        display={"flex"}
        container
        justifyContent={"space-between"}
        height={"6.25rem"}
        borderBottom={`${theme?.border?.xsmall} ${theme?.color?.dividerLight}`}
        sx={{
          backgroundColor: theme?.color?.background,
          "&:hover:not(.Mui-disabled)": {
            cursor: "pointer",
          },
        }}
      >
        <Grid
          item
          display={"flex"}
          px={4}
          gap={2}
          justifyContent={"left"}
          alignItems={"center"}
        >
          <Typography
            variant="h6"
            sx={{
              color: theme?.color?.primary,
              fontFamily: theme.font?.fontFamily.primary,
              fontWeight: "600",
            }}
          >
            My Profile
          </Typography>
        </Grid>
        <Grid item display={"flex"} alignItems={"center"} mr={4}>
          <Button
            sx={{ ...buttonStyles.outlinedDanger }}
            onClick={handleLogout}
          >
            Logout
          </Button>
        </Grid>
      </Grid>
      <Grid display={"flex"} justifyContent={"center"} p={4}>
        <Grid
          width={"80%"}
          borderRadius={4}
          sx={{ backgroundColor: theme?.color?.background }}
          display={"flex"}
          p={2}
        >
          <Grid
            width={"50%"}
            display={"flex"}
            flexDirection={"column"}
            alignItems={"center"}
            p={4}
            gap={2}
            borderRight={theme.border?.smallGrey}
          >
            <Typography
              sx={{
                fontFamily: theme.font?.fontFamily.primary,
                color: theme.color?.sideGrey,
                fontSize: theme.font?.fontSize.tableHeader,
              }}
            >
              Merchant Code
            </Typography>
            <Grid
              flex={2}
              display={"flex"}
              alignSelf={"center"}
              justifyContent={"center"}
            >
              <QRCode
                id="qrCodeDiv"
                value={external_id ? external_id : ""}
                size={128}
              />
            </Grid>
            <Button
              disabled={!qrCode}
              onClick={handlePrint}
              sx={{
                ...buttonStyles.containedSecondary,
                background: qrCode
                  ? theme.color?.secondary
                  : theme.color?.sideGrey,
                color: qrCode
                  ? theme.color?.greyBackground
                  : theme.color?.background,
                width: "18%",
              }}
            >
              Print Code
            </Button>
          </Grid>
          <Grid
            width={"50%"}
            display={"flex"}
            flexDirection={"column"}
            alignItems={"center"}
            justifyContent={"center"}
          >
            <Grid
              width={"80%"}
              display={"flex"}
              flexDirection={"column"}
              p={3}
              gap={2}
            >
              <Grid>
                <Typography
                  sx={{
                    fontFamily: theme.font?.fontFamily.primary,
                    color: theme.color?.sideGrey,
                    fontSize: theme.font?.fontSize.tableHeader,
                  }}
                >
                  Store Name
                </Typography>
                <Typography sx={{ fontFamily: theme.font?.fontFamily.primary }}>
                  {merchantName}
                </Typography>
              </Grid>
              <Grid>
                <Typography
                  sx={{
                    fontFamily: theme.font?.fontFamily.primary,
                    color: theme.color?.sideGrey,
                    fontSize: theme.font?.fontSize.tableHeader,
                  }}
                >
                  Company Name
                </Typography>
                <Typography sx={{ fontFamily: theme.font?.fontFamily.primary }}>
                  {companyName}
                </Typography>
              </Grid>
              <Grid>
                <Typography
                  sx={{
                    fontFamily: theme.font?.fontFamily.primary,
                    color: theme.color?.sideGrey,
                    fontSize: theme.font?.fontSize.tableHeader,
                  }}
                >
                  Store Code
                </Typography>
                <Typography sx={{ fontFamily: theme.font?.fontFamily.primary }}>
                  {storeCode}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default MerchantProfile;
